import { CustomMapPage } from 'pages/custom/shared/CustomMapPage';
import { CompanyButtonsWithProgramme } from 'pages/custom/shared/detail/CompanyButtonsWithProgramme';
import { S_PageStyle } from 'pages/page/PageStyle';
import { useContext, useEffect } from 'react';
import { CtxModal } from 'session/ctxModal';
import { CtxView } from 'session/ctxView';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const FestivalAtmosfera = (props: Props): JSX.Element => {
    const ctxModal = useContext(CtxModal);
    const ctxView = useContext(CtxView);

    useEffect(() => {
        ctxView.setCustomPageConfig({
            hideLogoInList: true
        });
    }, []);

    return (
        <S_FjellseterPage className={props.className}>
            <CustomMapPage
                mapId={'4a722a16-2518-4d61-a418-7b8a4761de6c'}
                header={{
                    logo: 'https://dvtqxks0zalev.cloudfront.net/a2fde0ce-62b6-4050-9d4e-b79d0a670325.png',
                    logoText: 'Festival Armosféra',
                    logoSubtext: '4.-6.8.2023',
                    linkText: 'Web',
                    link: 'https://festivalatmosfera.sk/'
                }}
                mapChildren={<></>}
                controls={
                    <CompanyButtonsWithProgramme
                        listTitle="places"
                        hideHighlight={true}
                        programmeTitle="Program"
                        onProgrammeClicked={() => {
                            ctxModal.setDetailListModal({
                                storyIds: [
                                    'de4fe59d-6926-4ace-98e5-3939d4788d20',
                                    '5e4d2942-9ad1-4466-ae82-29983dedc558',
                                    'de3bd970-9ffc-482a-8a94-c30b3c5caf71',
                                    '4f964821-1401-4f6d-bb1a-f74925561c18',
                                    '92d84981-48d5-4bb8-aeb9-8887c7062b75',
                                    '08b73ecb-cc9d-4fa6-9532-ad4a6259d0f8',
                                    'ebb88750-0e81-4f7c-a280-a776c8c357bb'
                                ],
                                sort: 'none',
                                show: 'all'
                            });
                        }}
                    />
                }
            />
        </S_FjellseterPage>
    );
};

const S_FjellseterPage = styled(S_PageStyle)`
    display: flex;
    flex-direction: column;
    position: relative;
`;
